exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "footer{color:hsla(0,0%,100%,.2);font-size:.8em;text-align:center;padding:10px}#privacy-policy-link{color:hsla(0,0%,100%,.2);text-decoration:none}#privacy-policy-link:hover{color:#926f41;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./src/components/Footer/footer.scss
// module id = 158
// module chunks = 0